import { IMAGES, PHONE_DISPLAY, PHONE_TEL } from "@/components/shared";

export default function Hero() {
  return (
    <header id="top" className="relative pt-16 pb-20 px-6 overflow-hidden honeycomb border-b border-[#d4af37]/15" data-testid="hero-section">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[#d4af37]/30 bg-[#121216] text-[11px] font-mono text-[#d4af37] mb-6 d1-fade d1-f1">
            <span className="w-2 h-2 rounded-full bg-[#d4af37] animate-pulse"></span>
            <span>Physical + Digital Infrastructure</span>
          </div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold uppercase leading-[0.95] tracking-tight text-white mb-6">
            <span className="ln"><span>One System.</span></span>
            <span className="ln"><span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] via-[#fff4cc] to-[#c0c0c0]">Complete</span></span>
            <span className="ln"><span>Solutions.</span></span>
          </h1>
          <p className="text-zinc-300 text-base sm:text-lg max-w-xl leading-relaxed mb-8 d1-fade d1-f2">
            Professional technology installation and digital solutions for homes and businesses.
            From TV mounting and smart home technology to commercial networking, data center
            infrastructure, and digital innovation.
          </p>
          <div className="flex flex-wrap items-center gap-4 d1-fade d1-f3">
            <a
              href="/services"
              data-testid="hero-explore-btn"
              className="px-8 py-4 rounded bg-gradient-to-r from-[#d4af37] to-[#e6ca65] text-black font-bold uppercase tracking-wider text-sm hover:opacity-95 transition-opacity shadow-lg shadow-[#d4af37]/25"
            >
              Explore Services →
            </a>
            <a
              href={PHONE_TEL}
              data-testid="hero-call-btn"
              className="flex items-center gap-2 text-zinc-300 hover:text-[#d4af37] transition-colors font-mono text-sm"
            >
              <svg className="w-4 h-4 text-[#d4af37]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              {PHONE_DISPLAY}
            </a>
          </div>
        </div>

        <div className="lg:col-span-5 relative d1-fade d1-f2">
          <div className="relative rounded-xl overflow-hidden gold-border aspect-[4/3] bg-[#121216]">
            <img
              src={IMAGES.hero}
              alt="Structured fiber cabling and glowing server rack in a Dallas data center"
              className="absolute inset-0 w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-black/30"></div>
            <svg className="absolute inset-0 w-full h-full opacity-20" preserveAspectRatio="none" viewBox="0 0 100 100" aria-hidden="true">
              <path d="M0 20 H100 M0 40 H100 M0 60 H100 M0 80 H100 M20 0 V100 M50 0 V100 M80 0 V100" stroke="#d4af37" strokeWidth="0.5" />
              <circle cx="50" cy="50" r="18" stroke="#d4af37" strokeWidth="1" fill="none" />
            </svg>
            <div className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-black/90 via-black/40 to-transparent">
              <span className="text-[10px] font-mono uppercase tracking-widest text-[#d4af37] block">DFW Infrastructure Hub</span>
              <p className="text-xs text-zinc-300 font-medium mt-0.5">Physical wiring meets automated digital intelligence.</p>
            </div>
          </div>
          <div className="absolute -bottom-4 -left-4 px-4 py-2.5 rounded bg-[#121216] border border-[#d4af37]/40 shadow-xl flex items-center gap-3">
            <span className="w-2.5 h-2.5 rounded-full bg-emerald-400 animate-ping"></span>
            <span className="text-[11px] font-mono text-zinc-200">Residential · Commercial · Data Centers</span>
          </div>
        </div>
      </div>
    </header>
  );
}
